import { render, staticRenderFns } from "./ArticleCard.vue?vue&type=template&id=3feabb7b&scoped=true&"
import script from "./ArticleCard.vue?vue&type=script&lang=js&"
export * from "./ArticleCard.vue?vue&type=script&lang=js&"
import style0 from "./ArticleCard.vue?vue&type=style&index=0&id=3feabb7b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3feabb7b",
  null
  
)

export default component.exports